import React from 'react'
import {Row, Col} from 'reactstrap';
//import {Link} from 'react-router-dom'
import moment from 'moment';
import {formatLocalNumber} from '../utils/Strings'
import SalesRowDetails from './SalesRowDetails'

export default class SalesRow extends React.Component{
  
//  handleReserve(idx){
//    //alert(idx)
//    this.props.onCourseChoose(idx)
//  }
 
  render() {
    var r=this.props.data;
    var strPeriod=r.period
    var strPeriodDate=moment(r.periodStart).format('YYYY-MM-DD')
    if ((this.props.periodType==="month") || (this.props.periodType==="day"))
      strPeriodDate=''
    else if (strPeriod===strPeriodDate)
      strPeriodDate=''
    else {
      strPeriodDate += " - " + moment(r.periodFinish).format('MM-DD')
    }
    //strPeriodDate=JSON.stringify(this.props.periodType)
    
    return (      
      <Row className="align-items-top">
        <Col lg="1" xs={{size: 4, order: 1}}>
        <div className="periodDesc">{strPeriod}</div>
        <div className="periodDates">{strPeriodDate}</div>
        </Col>
                
        
        <Col lg="1" xs={{size: 2, order: 2}}>
        <div className="listLabel">Sprzedaż</div>
        <div className="summaryValue">{formatLocalNumber(r.totalSale)}</div>
        <div className="summaryExtras right">{formatLocalNumber(r.totalSaleNetto)}<br/>{formatLocalNumber(r.totalSaleVat)}</div>
        </Col>
        
        <Col lg="1" xs={{size: 2, order: 2}}>
        <div className="listLabel">Zwroty</div>
        <div className="summaryValue">{formatLocalNumber(r.totalRefund)}</div>
        <div className="summaryExtras right">{formatLocalNumber(r.totalRefundNetto)}<br/>{formatLocalNumber(r.totalRefundVat)}</div>
        </Col>
        
        <Col lg="1" xs={{size: 2, order: 2}}>
        <div className="listLabel">Bilans</div>
        <div className="summaryValue">{formatLocalNumber(r.totalSale-r.totalRefund)}</div>
        <div className="summaryExtras right">{formatLocalNumber(r.totalSaleNetto-r.totalRefundNetto)}<br/>{formatLocalNumber(r.totalSaleVat-r.totalRefundVat)}</div>
        </Col>

        <Col lg="1" xs={{size: 2, order: 2}}>
        <div className="listLabel">Potr. zwr.</div>
        <div className="summaryValue">{formatLocalNumber(r.totalRefundDeduction)}</div>
        <div className="summaryExtras right">{formatLocalNumber(r.totalRefundAgent)}</div>
        </Col>
        
        <Col lg={{size: 7, offset:0}} xs={{size: 12, offset:0}}>               
        <SalesRowDetails data={r.companies}/>
        </Col>
                            
      </Row>      
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SalesRow.js